<template>
    <div>
        <div class="container">
            <div class="consent-content">
              <h3 class="p1">中華人民共和國附錄</h3>
            </div>
            <div class="consent-content">
                <h3 class="p1">K11 LP / KLUB 11</h3>
            </div>

            <div class="consents-content" id="k11">
                <p><strong>請在下面的方框中打勾，以確認您的同意。</strong></p>
                <p><strong>&nbsp;</strong></p>
                <div class="form-content">
                    <div class="consent-item">
                        <div class="flex">
                            <div class="check-box-container" :class="{ active: getPipl('CNPIPL_1_AGREE') }" v-on:click="setPIPL('CNPIPL_1_AGREE')"></div>
                            <p>本人理解上述及<a target="_blank" href="https://klub-11.com/zh-hk/privacy-policy/">K11 LP
                                私隱政策聲明</a>、<a target="_blank" href="https://www.nwd.com.hk/zh-hant/privacy-policy">新世界集團私隱政策聲明</a>、<a
                                    target="_blank" href="https://media.k11.com/general_assets/KLUB_11_PICS_TC.pdf">個人資料收集聲明</a>及<a
                                    target="_blank" href="https://media.k11.com/general_assets/KLUB_11_PRC_Addendum_TC_incl._Minor_Rules___Annex_A.pdf">中華人民共和國附錄</a>中的全部內容，並同意根據上述有關目的對本人的個人信息的收集、使用及處理。
                            </p>
                        </div>
                    </div>
                    <div class="consent-item">
                        <div class="flex">
                            <div class="check-box-container" :class="{ active: getPipl('CNPIPL_1_GROUP') }" v-on:click="setPIPL('CNPIPL_1_GROUP')"></div>
                            <div class="child-container">
                                <div class="line"></div>
                                <p>通過勾選此方框，本人亦同意對本人的個人信息進行以下全部處理。
                                    本人理解，本人可通過取消勾選以下任一方框以拒絕其中內容，
                                    但K11 LP可能因此無法在未獲本人相關同意的情況下向本人提供有關産品/服務。</p>
                                <div class="child-check-box-container">
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox" :class="{ active: getPipl('CNPIPL_3_SENSITIVE') }" v-on:click="setPIPL('CNPIPL_3_SENSITIVE')"></div>
                                            <p>本人同意根據上述有關目的對本人的敏感個人信息的收集及處理。
                                            </p>
                                        </div>
                                    </div>
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox" :class="{ active: getPipl('CNPIPL_4_TRANSFER') }" v-on:click="setPIPL('CNPIPL_4_TRANSFER')"></div>
                                            <p>本人同意將本人的個人信息（包括敏感個人信息）轉移至中國內地以外地區。
                                            </p>
                                        </div>
                                    </div>
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox" :class="{ active: getPipl('CNPIPL_5_3RD') }" v-on:click="setPIPL('CNPIPL_5_3RD')"></div>
                                            <p>本人同意向第三方提供本人的個人信息（包括敏感個人信息）。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="consent-item">
                        <div class="flex">
                            <div class="check-box-container" :class="{ active: getPipl('CNPIPL_2_GROUP') }" v-on:click="setPIPL('CNPIPL_2_GROUP')"></div>
                            <div class="child-container">
                                <div class="line"></div>
                                <p>通過勾選此方框，本人亦同意對本人的個人信息進行以下處理。</p>
                                <div class="child-check-box-container">
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox" :class="{ active: getPipl('CNPIPL_7_DIRECT_OPTIN') }" v-on:click="setPIPL('CNPIPL_7_DIRECT_OPTIN')"></div>
                                            <p>本人同意接受K11 LP的直接促銷，並同意其將本人的個人信息用于直接促銷目的。</p>
                                        </div>
                                    </div>
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox" :class="{ active: getPipl('CNPIPL_6_OPTIN') }" v-on:click="setPIPL('CNPIPL_6_OPTIN')"></div>
                                            <p>本人同意K11 LP向新世界集團的關聯公司及營銷合作夥伴共享本人的個人信息，以便在香港和香港以外地區用于直接促銷和跨業直銷目的。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-content-bottom">
                    <p>如本人不同意<a target='_blank' href='https://klub-11.com/zh-hk/privacy-policy/'>K11 LP私隱政策聲明</a>、 
                        <a target='_blank' href='https://www.nwd.com.hk/zh-hant/privacy-policy'>新世界集團私隱政策聲明</a>、
                        <a target='_blank' href='https://media.k11.com/general_assets/KLUB_11_PICS_TC.pdf'>個人資料收集聲明</a>
                        及<a arget='_blank' href='https://media.k11.com/general_assets/KLUB_11_PRC_Addendum_TC_incl._Minor_Rules___Annex_A.pdf'>中華人民共和國附錄</a>中的內容，
                        本人理解本人可以通過寫信至香港九龍尖沙咀麽地道66號尖沙咀中心4樓（標記為機密並注明K11 LP）
                        聯系K11 LP的個人資料私隱專員，
                        以了解本人的選擇和法律權利，並作出適當的安排。</p>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="consent-content">
                <h3 class="p1">K Dollar 獎賞計劃</h3>
            </div>

            <div class="consents-content" id="kdp">
                <p><strong>請在下面的方框中打勾，以確認您的同意。</strong></p>
                <p><strong>&nbsp;</strong></p>
                <div class="form-content">
                    <div class="consent-item">
                        <div class="flex">
                            <div class="check-box-container" :class="{ active: getPipl('KDP_CNPIPL_1_AGREE') }" v-on:click="setPIPL('KDP_CNPIPL_1_AGREE')"></div>
                            <p><span
                                    style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">本人理解上述及</span><a
                                    style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;"
                                    target="_blank" href="https://hk.krewards.com/zh-hk/privacy-policy/">私隱政策聲明</a><span
                                    style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">、<a
                                    target="_blank" href="https://hk.krewards.com/zh-hk/pipl-prc-addendum/">中華人民共和國附錄</a>及</span><a
                                    style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;"
                                    target="_blank" href="https://hk.krewards.com/zh-hk/personal-information-collection-statement/">個人資料收集聲明</a><span
                                    style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">中的全部內容，並同意根據有關目的對本人的個人資訊的收集、使用及處理。</span>
                            </p>
                        </div>
                    </div>
                    <div class="consent-item">
                        <div class="flex">
                            <div class="check-box-container" :class="{ active: getPipl('KDP_CNPIPL_1_GROUP') }" v-on:click="setPIPL('KDP_CNPIPL_1_GROUP')"></div>
                            <div class="child-container">
                                <div class="line"></div>
                                <p>
                                    通過勾選此方框，本人亦同意對本人的個人信息進行以下全部處理。本人理解，本人可通過取消勾選以下任一方框以拒絕其中內容，但MPNCL可能因此無法在未獲本人相關同意的情況下向本人提供有關産品/服務。</p>
                                <div class="child-check-box-container">
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox" :class="{ active: getPipl('KDP_CNPIPL_3_SENSITIVE') }" v-on:click="setPIPL('KDP_CNPIPL_3_SENSITIVE')"></div>
                                            <p>本人同意根據有關目的對本人的敏感個人信息的收集及處理。
                                            </p>
                                        </div>
                                    </div>
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox" :class="{ active: getPipl('KDP_CNPIPL_4_TRANSFER') }" v-on:click="setPIPL('KDP_CNPIPL_4_TRANSFER')"></div>
                                            <p>本人同意將本人的個人信息（包括敏感個人信息）轉移至中國內地以外地區。
                                            </p>
                                        </div>
                                    </div>
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox" :class="{ active: getPipl('KDP_CNPIPL_5_3RD') }" v-on:click="setPIPL('KDP_CNPIPL_5_3RD')"></div>
                                            <p>本人同意向第三方提供本人的個人信息（包括敏感個人信息）。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="consent-item">
                        <div class="flex">
                            <div class="check-box-container" :class="{ active: getPipl('KDP_CNPIPL_2_GROUP') }" v-on:click="setPIPL('KDP_CNPIPL_2_GROUP')"></div>
                            <div class="child-container">
                                <div class="line"></div>
                                <p>通過勾選此方框，本人亦同意對本人的個人資訊進行以下處理。</p>
                                <div class="child-check-box-container">
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox" :class="{ active: getPipl('KDP_CNPIPL_7_DIRECT_OPTIN') }" v-on:click="setPIPL('KDP_CNPIPL_7_DIRECT_OPTIN')"></div>
                                            <p>本人同意接受MPNCL的直接促銷，並同意其將本人的個人信息用于直接促銷目的。</p>
                                        </div>
                                    </div>
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox" :class="{ active: getPipl('KDP_CNPIPL_6_OPTIN') }" v-on:click="setPIPL('KDP_CNPIPL_6_OPTIN')"></div>
                                            <p>
                                                本人同意MPNCL向關聯公司及營銷合作夥伴共享本人的個人信息，以便在香港和香港以外地區用于直接促銷和跨業直銷目的。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-content-bottom">
                    <p>如本人不同意<a target='_blank' href='https://hk.krewards.com/zh-hk/privacy-policy/'>私隱政策聲明</a>、
                    <a target='_blank' href='https://hk.krewards.com/zh-hk/pipl-prc-addendum/'>中華人民共和國附錄</a>及
                    <a target='_blank' href='https://hk.krewards.com/zh-hk/personal-information-collection-statement/'>個人資料收集聲明</a>中的內容，
                    本人理解本人可以通過發送電子郵件到<a
                            target="_blank" href="mailto:privacy@krewards.com">privacy@krewards.com</a>
                    或寫信至香港九龍尖沙咀麽地道66號尖沙咀中心4樓（標記為機密並注明新領域網絡控股有限公司）聯系新領域網絡控股有限公司的個人資料私隱專員，以了解本人的選擇和法律權利，並作出適當的安排。
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapGetters, mapMutations} from "vuex";
import pipl from "@/views/pipl.vue";

export default {
    name: "piplprompt",
    props: [],
    data() {
        return {}
    },
    components: {},
    created() {
    },
    computed: {
        ...mapGetters(['getPipl']),
    },
    methods: {
        ...mapMutations(['setPIPL']),
    },
};
</script>


<style scoped>
@font-face {
    font-family: "Proxima Nova";
    src: url("[regular]");
    font-weight: 400;
}

@font-face {
    font-family: "Proxima Nova";
    src: url("[semi-bold]");
    font-weight: 600;
}

@font-face {
    font-family: "Marcellus";
    src: url("[marcellus-regular]");
    font-weight: 400;
}

body {
    margin: 0px;
    color: #504e49;
    font-family: "Proxima Nova";
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
}

.container {
    padding: 0px 20px;
}

h2 {
    letter-spacing: 0.2px;
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
    margin: 0px 0px 4px;
    font-family: "Marcellus";
}

p {
    margin: 0px;
}

h6 {
    font-size: 14px;
    line-height: 16px;
    font-weight: 600;
    margin: 0px 0px 8px;
    color: #504e49;
}

.flex {
    display: flex;
    flex: 1 0 100%;
}

a {
    color: #baa16f;
    text-decoration: underline;
}

.consents-content {
    font-size: 14px;
    line-height: 16px;
    //color: #928f89;
}

.form-content {
    padding: 16px 0px 0px;
}

.consent-item,
.consent-content {
    margin-bottom: 24px;
}

.child-consent-item {
    margin-top: 12px;
}

.consent-item p {
    margin-left: 8px;
}

.check-box-container {
    border: 2px solid #cecdca;
    border-radius: 8px;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-right: 8px;
}

.check-box-container.active {
    background-color: gray;
}

.check-box-container.active::before {
    content: "";
    display: block;
    transform: rotate(45deg);
    height: 11px;
    width: 5px;
    border-bottom: 2px solid white;
    border-right: 2px solid white;
    margin-left: 6px;
    margin-top: 2px;
}

.child-check-box-container {
    padding-top: 12px;
}

.child-container {
    position: relative;
}

.line {
    position: absolute;
    width: 1px;
    background: #e7e6e4;
    height: calc(100% - 48px);
    margin-top: 48px;
    left: -20px;
}

.form-content-bottom {
    color: #504E49;
    padding-bottom: 24px;
    font-size: 16px;
    line-height: 24px;
}
</style>
